import { Platform } from 'react-native';
import { PERMISSIONS } from 'react-native-permissions';

const localPermissions = {
  NETWORK: 'NETWORK',
  PERSONALIZED_SERVICES: 'PERSONALIZED_SERVICES',
  BIOMETRIC: 'BIOMETRIC',
};

const androidPermissions = {
  ...PERMISSIONS.ANDROID,
  ...localPermissions,
};

const androidPermissionTypes = {
  ACCEPT_HANDOVER: 'ACCEPT_HANDOVER',
  ACCESS_BACKGROUND_LOCATION: 'ACCESS_BACKGROUND_LOCATION',
  ACCESS_COARSE_LOCATION: 'ACCESS_COARSE_LOCATION',
  ACCESS_FINE_LOCATION: 'ACCESS_FINE_LOCATION',
  ACTIVITY_RECOGNITION: 'ACTIVITY_RECOGNITION',
  ADD_VOICEMAIL: 'ADD_VOICEMAIL',
  ANSWER_PHONE_CALLS: 'ANSWER_PHONE_CALLS',
  BODY_SENSORS: 'BODY_SENSORS',
  CALL_PHONE: 'CALL_PHONE',
  CAMERA: 'CAMERA',
  GET_ACCOUNTS: 'GET_ACCOUNTS',
  PROCESS_OUTGOING_CALLS: 'PROCESS_OUTGOING_CALLS',
  READ_CALENDAR: 'READ_CALENDAR',
  READ_CALL_LOG: 'READ_CALL_LOG',
  READ_CONTACTS: 'READ_CONTACTS',
  READ_EXTERNAL_STORAGE: 'READ_EXTERNAL_STORAGE',
  READ_PHONE_NUMBERS: 'READ_PHONE_NUMBERS',
  READ_PHONE_STATE: 'READ_PHONE_STATE',
  READ_SMS: 'READ_SMS',
  RECEIVE_MMS: 'RECEIVE_MMS',
  RECEIVE_SMS: 'RECEIVE_SMS',
  RECEIVE_WAP_PUSH: 'RECEIVE_WAP_PUSH',
  RECORD_AUDIO: 'RECORD_AUDIO',
  SEND_SMS: 'SEND_SMS',
  USE_SIP: 'USE_SIP',
  WRITE_CALENDAR: 'WRITE_CALENDAR',
  WRITE_CALL_LOG: 'WRITE_CALL_LOG',
  WRITE_CONTACTS: 'WRITE_CONTACTS',
  WRITE_EXTERNAL_STORAGE: 'WRITE_EXTERNAL_STORAGE',
  ...localPermissions,
};

const IOSPermissions = {
  ...PERMISSIONS.IOS,
  ...localPermissions,
  PUSH_NOTIFICATIONS: 'PUSH_NOTIFICATIONS',
};

const IOSPermissionTypes = {
  APP_TRACKING_TRANSPARENCY: 'APP_TRACKING_TRANSPARENCY',
  BLUETOOTH_PERIPHERAL: 'BLUETOOTH_PERIPHERAL',
  CALENDARS: 'CALENDARS',
  CAMERA: 'CAMERA',
  CONTACTS: 'CONTACTS',
  FACE_ID: 'FACE_ID',
  LOCATION_ALWAYS: 'LOCATION_ALWAYS',
  LOCATION_WHEN_IN_USE: 'LOCATION_WHEN_IN_USE',
  MEDIA_LIBRARY: 'MEDIA_LIBRARY',
  MICROPHONE: 'MICROPHONE',
  MOTION: 'MOTION',
  PHOTO_LIBRARY: 'PHOTO_LIBRARY',
  REMINDERS: 'REMINDERS',
  SIRI: 'SIRI',
  SPEECH_RECOGNITION: 'SPEECH_RECOGNITION',
  STOREKIT: 'STOREKIT',
  PUSH_NOTIFICATIONS: 'PUSH_NOTIFICATIONS',
  ...localPermissions,
};

const permissions = {
  ...Platform.select({
    android: androidPermissions,
    ios: IOSPermissions,
  }),
};

export { androidPermissionTypes, IOSPermissionTypes, localPermissions, permissions };
